import React, { FC, ReactElement } from "react";

import { Grid, Typography } from "@mui/material";

const SettingRow: FC<any> = ({ title, children }): ReactElement => {
  return (
    <Grid container item direction="row" alignItems="center" my={2}>
      <Typography
        color="primary"
        sx={{
          fontSize: "14px",
          marginRight: "20px",
          width: "105px",
        }}
        fontWeight="bolder"
      >
        {title}: &nbsp;
      </Typography>
      {children}
    </Grid>
  );
};

export default SettingRow;
